import React from 'react'
export default function ChevronIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 13 7">
            <path d="M1.19.4c-.43.42-.43 1.1 0 1.53L5.77 6.5A1.08 1.08 0 1 0 7.3 4.98L2.7.4A1.08 1.08 0 0 0 1.2.4Z"/>
            <path d="M11.97.4a1.08 1.08 0 0 0-1.53 0L5.86 4.98A1.08 1.08 0 1 0 7.4 6.51l4.58-4.58c.42-.42.42-1.1 0-1.53Z"/>
        </svg>
    )
}


